<style scoped lang="less">
.container {
  padding: 24px;
}

.content {
  background: #fff;
  padding: 24px;
}

.pagination {
  margin-top: 20px;
  text-align: center;
}
</style>
<template>
  <div class="container">
    <div class="content">
      <div>
        <Button type="primary" @click="showAddTemplateModal" icon="plus">新增模板</Button>
      </div>
      <br/>
      <Table :columns="columns" :data="data"></Table>
      <div class="pagination">
        <Page :current="currentPage" :total="total" @on-change="onChangePage"></Page>
      </div>
      <Modal
        v-model="visible"
        title="编辑模板"
        :mask-closable="false"
        @on-ok="create"
        :loading="loading"
      >
        <Form ref="formValidate" 
          :model="form" 
          :rules="ruleValidate" 
          :label-width="90"
        >
          <FormItem label="模板名称" prop="name">
            <Input v-model="form.name" placeholder="请输入模板名称"></Input>
          </FormItem>
          <FormItem label="格式" prop="format">
            <Select v-model="form.format" placeholder="请选择格式">
              <Option value="mp4">MP4</Option>
              <Option value="flv">FLV</Option>
            </Select>
          </FormItem>
          <FormItem label="宽度" prop="width">
            <Input v-model="form.width" placeholder="请输入宽度" style="width:100px">
              <span slot="append">px</span>
            </Input>
          </FormItem>
          <FormItem label="高度" prop="height">
            <Input v-model="form.height" placeholder="请输入高度" style="width:100px">
              <span slot="append">px</span>
            </Input>
          </FormItem>
          <FormItem label="videoCodec" prop="videoCodec">
            <Select v-model="form.videoCodec" placeholder="请选择视频Codec">
              <Option value="h264">H264</Option>
              <Option value="h265">H265</Option>
            </Select>
          </FormItem>
          <FormItem label="视频码率" prop="videoBitRate">
            <InputNumber v-model="form.videoBitRate" placeholder="请输入视频码率"></InputNumber>
          </FormItem>
          <FormItem label="音频Codec" prop="audioCodec">
            <Select v-model="form.audioCodec" placeholder="请选择视频Codec">
              <Option value="mp3">MP3</Option>
              <Option value="acc">ACC</Option>
            </Select>
          </FormItem>
          <FormItem label="音频码率" prop="audioBitRate">
            <InputNumber v-model="form.audioBitRate" placeholder="请输入音频码率"></InputNumber>
          </FormItem>
          <FormItem label="文件大小" prop="fileSize">
            <Input v-model="form.fileSize" placeholder="请输入文件大小" style="width:150px">
              <span slot="append">mb</span>
            </Input>
            文件大小不能不小于1M。
          </FormItem>
        </Form>
         <div slot="footer">
            <Button type="primary" @click="create">保存</Button>
            <Button @click="visible=false">取消</Button>
         </div>
      </Modal>
    </div>
  </div>
</template>
<script>
import { GET_TEMPLATE, CREATE_TEMPLATE, GET_TEMPLATE_LIST } from "@/utils/api";
import pagination from "@/mixins/pagination";
import { Button, Poptip } from "iview";

export default {
  mixins: [pagination],
  data() {
    return {
      data: [],
      form: {},
      loading: true,
      visible: false,
      editIndex: -1,
      ruleValidate: {
        name: [
          {
            required: true,
            message: "名称不能为空",
          }
        ],
        width: [
          {
            required: true,
            message: "宽度不能为空",
          }
        ],
        height: [
          {
            required: true,
            message: "高度不能为空",
          }
        ],
        videoCodec: [
          {
            required: true,
            message: "视频码率不能为空",
          }
        ],
        audioCodec: [
          {
            required: true,
            message: "音频码率不能为空",
          }
        ],
        fileSize: [
          {
            required: true,
            message: "文件大小不能为空",
          }
        ]
      },
      columns: [
        {
          title: "模板ID",
          key: "id"
        },
        {
          title: "名称",
          key: "name"
        },
        {
          title: "尺寸",
          key: "width",
          render(h, { row }) {
            return (
              <span>
                {row.width}*{row.height}
              </span>
            );
          }
        },
        {
          title: "格式",
          key: "format"
        },
        {
          title: "视频codec",
          key: "videoCodec"
        },
        {
          title: "视频码率",
          key: "videoBitRate"
        },
        {
          title: "音频codec",
          key: "audioCodec"
        },
        {
          title: "音频码率",
          key: "audioBitRate"
        },
        {
          title: "大小",
          key: "fileSize",
          render(h, { row }) {
            return <span>{row.fileSize / 1024 / 1024}MB</span>;
          }
        },
        {
          title: "操作",
          key: "status",
          render: (h, params) => {
            if (params.row.id) {
              return (
                <div>
                  <Button
                    type="primary"
                    size="small"
                    onClick={() => this.editTemplate(params.row)}
                  >
                    修改
                  </Button>&nbsp;
                  <Poptip
                    confirm
                    title="你确定删除此模板?"
                    onOn-ok={() => {
                      console.log(this);
                      this.form = params.row;
                      this.form.status = 2;
                      this.create(false);
                    }}
                  >
                    <Button type="error" size="small">
                      删除
                    </Button>
                  </Poptip>
                </div>
              );
            }
          }
        }
      ]
    };
  },
  mounted() {
    this.fetch();
  },
  methods: {
    fetch() {
      this.$http
        .get(GET_TEMPLATE_LIST, {
          params: {
            page: this.currentPage,
            pageSize: this.pageSize,
            sortBy: "-vcs_template.id",
            status: 1
          }
        })
        .then(response => {
          const { code, data, errorMessage } = response.body;
          if (code === 0) {
            this.data = data.list;
            this.total = data.totalCount;
          } else {
            this.$Message.error(errorMessage);
          }
        });
    },
    create() {
      this.$refs.formValidate.validate(valid => {
        if (valid) {
          let form = Object.assign({}, this.form);
          ["width", "height", "fileSize"].forEach(i => {
            form[i] = parseInt(form[i]);
          });
          form.fileSize = form.fileSize * 1024 * 1024;

          this.$http.post(CREATE_TEMPLATE, form).then(
            response => {
              const { code, data, errorMessage } = response.body;
              if (code === 0) {
                this.$Message.info("保存成功");
                this.visible=false;
                this.fetch();
              } else {
                this.$Message.error(errorMessage);
              }
            },
            () => {
              this.$Message.error("保存失败");
            }
          );
        }
      });
      
    },
    addRow() {
      this.data.push({
        size: "11"
      });
      this.editIndex = this.data.length - 1;
      this.form = this.data[this.editIndex];
    },
    editTemplate(data) {
      /// if(id){
      //   this.$http.get(GET_TEMPLATE,{
      //     params:{
      //       id:id
      //     }
      //   }).then((response) => {
      //     const {code, data, errorMessage} = response.body;
      //     if (code === 0) {
      this.form = Object.assign({}, data);
      this.form.fileSize = data.fileSize / 1024 / 1024
      this.visible = true;
      //   } else {
      //     this.$Message.error(errorMessage)
      //   }
      // })
      //}
    },
    showAddTemplateModal() {
      this.form = {
        videoCodec: "h264",
        format: "mp4",
        audioCodec: "mp3"
      };
      this.visible = true;
    }
  }
};
</script>
